import { LayerImage } from '@/types/models';
import { LayerObjectAdapter } from '@/utils/layer/LayerObjectAdapter';

export function getLayerImageAdapterId(id: number): string {
  return `img-${id}`;
}

export class LayerImageAdapter implements LayerImage, LayerObjectAdapter {
  public id: number;

  public x: number;

  public y: number;

  public z: number;

  public width: number;

  public height: number;

  public layer: number;

  public glyph: number | null;

  constructor(layerImage: LayerImage) {
    this.id = layerImage.id;
    this.x = layerImage.x;
    this.y = layerImage.y;
    this.z = layerImage.z;
    this.width = layerImage.width;
    this.height = layerImage.height;
    this.layer = layerImage.layer;
    this.glyph = layerImage.glyph;
  }

  public getId(): string {
    return getLayerImageAdapterId(this.id);
  }

  public getOriginalId(): number {
    return this.id;
  }
}
